import { gsap } from 'gsap';

const clearElements = (targets: GSAPTweenTarget[]) => {
  gsap.set(targets, { clearProps: 'all' });
};

export default clearElements;
